import _extends from '@babel/runtime/helpers/extends';
import React__default, { useContext } from 'react';
import { S as SelectOptionGroupContainer, D as DropdownDivider, a as StyledSelectOptionGroupHeader } from './SelectOptionGroup.styles-DieCzSoN.js';
import { S as SelectList } from '../SelectList-CKJ1ZhdU.js';
import { a as SelectOptionGroupDisplayName } from '../utils/displayNames-DWYGtsUp.js';
import { S as SelectListContext } from '../SelectListContext-D8hyna51.js';
import { T as TaktIdProvider } from '../../TaktIdContext/TaktIdContext-C6vdL-6Z.js';
import { c as createStormTaktId } from '../../TaktIdContext/TaktIdContext.utils-B0CzqlN8.js';

const SelectOptionGroup = ({
  label,
  hideLabel,
  onClick,
  noWrap,
  taktId,
  taktValue,
  selectedValue,
  ...rest
}) => {
  const {
    mobileFullScreen,
    multiple,
    selectedValue: selectedValueFromContext,
    noWrap: noWrapFromContext,
    onClick: selectListOnClick,
    afterOnSelect
  } = useContext(SelectListContext);
  return /*#__PURE__*/React__default.createElement(TaktIdProvider, {
    taktId: taktId,
    taktValue: taktValue,
    fallbackId: createStormTaktId('select-option-group')
  }, /*#__PURE__*/React__default.createElement(SelectOptionGroupContainer, null, !mobileFullScreen && /*#__PURE__*/React__default.createElement(DropdownDivider, null), /*#__PURE__*/React__default.createElement(StyledSelectOptionGroupHeader, {
    srOnly: hideLabel
  }, label), /*#__PURE__*/React__default.createElement(SelectList, _extends({
    onChange: onClick || selectListOnClick
  }, rest, {
    mobileFullScreen: mobileFullScreen,
    multiple: multiple,
    selectedValue: selectedValue || selectedValueFromContext,
    noWrap: noWrapFromContext || noWrap,
    afterOnSelect: afterOnSelect
  }))));
};
SelectOptionGroup.displayName = SelectOptionGroupDisplayName;

export { SelectOptionGroup as S };
//# sourceMappingURL=SelectOptionGroup-BWQUhq5y.js.map
